// aws-exports.js
const awsConfig = {
  region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_KvFGg2fqZ',
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '4bcusft4kele42f8bcmlga1boq',
  oauth: {
    domain: process.env.REACT_APP_COGNITO_DOMAIN,
    scope: (process.env.REACT_APP_COGNITO_SCOPE || 'email openid phone').split(' '),
    redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_URI,
    redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_URI,
    responseType: 'code',
  },
};

export default awsConfig;